import React from 'react';
import { InterviewSlotsViewRendererProps } from '../types';

import Desktop from './Desktop';

function ViewRenderer(props: InterviewSlotsViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
